import { render } from "./CardIcons.vue?vue&type=template&id=22a29852&lang=pug"
import script from "./CardIcons.vue?vue&type=script&lang=js"
export * from "./CardIcons.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__